import React, { useRef } from 'react';
import Button from '../button';
import Dialog from '../../componentes/dialog';
import KEYS from '../../utils/key-codes';
import jsxArray from '../../utils/jsx-array';
import { ButtonToolbar } from 'reactstrap';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { prepareHtml } from 'src/utils/html';

function Confirm({
  title = 'label.confirmar',
  message,
  labelCancel,
  labelConfirm,
  isFunction = false,
  isFormattedText = false,
  width = 500,
  handleCancel,
  handleConfirm,
  ...other
}) {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const dialogRef = useRef(null);

  function handleCancelClick() {
    handleCancel && handleCancel();
    dialogRef.current?.close();
  }

  function handleConfirmClick() {
    handleConfirm && handleConfirm();
    dialogRef.current?.close();
  }

  function handleKeyDown(event) {
    const keyCode = event.which || event.keyCode;

    if (keyCode === KEYS.ESC) {
      handleCancelClick();
      event.preventDefault();
    } else if (keyCode === KEYS.ENTER && event.target.tagName !== 'TEXTAREA') {
      handleConfirmClick();
      event.preventDefault();
    }
  }

  const actions = jsxArray(
    <ButtonToolbar>
      <Button onClick={handleCancelClick} color="secondary">
        {labelCancel
          ? labelCancel
          : intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      <Button
        className="ml-2"
        autoFocus
        type="primary"
        onClick={handleConfirmClick}
      >
        {labelConfirm
          ? labelConfirm
          : intl.formatMessage({ id: 'label.confirmar' })}
      </Button>
    </ButtonToolbar>
  );

  let messageContent;
  if (isFunction) {
    messageContent = message();
  } else if (isFormattedText) {
    messageContent = <div dangerouslySetInnerHTML={prepareHtml(message)} />;
  } else {
    messageContent = message;
  }

  return (
    <div onKeyDown={handleKeyDown} role="presentation">
      <Dialog
        {...other}
        resources={resources}
        width={width}
        ref={dialogRef}
        title={title}
        actions={actions}
        onRequestClose={handleCancelClick}
        allowMaximize={false}
        padContent
      >
        <div className="mb-3">{messageContent}</div>
      </Dialog>
    </div>
  );
}

export default Confirm;
